"use client";

import { useLocale } from "next-intl";
import { useCallback } from "react";
import { AppLocale, DEFAULT_LOCALE, isSupportedLocale } from "./config";
import { translateRaw } from "./rawTranslations";

export function useAutoTranslate() {
  const localeFromIntl = useLocale();
  const locale: AppLocale = isSupportedLocale(localeFromIntl)
    ? localeFromIntl
    : DEFAULT_LOCALE;

  return useCallback(
    (value?: string | null) => translateRaw(value, locale),
    [locale],
  );
}
